import { ReactElement } from 'react';

import { WaitlistEntry } from '@dreryk/egabinet-waitlist-frontend-api';

import { BookAppointmentButton } from './BookAppointmentButton';
import { ConfirmReservationButton } from './ConfirmReservationButton';
import { RestoreEntryButton } from './RestoreEntryButton';

type OptionsCellProps = {
   readonly waitlistEntry: WaitlistEntry;
};

export const OptionsCell = (props: OptionsCellProps): ReactElement | null => {
   if (props.waitlistEntry.status === 'PENDING') {
      return (
         <BookAppointmentButton
            entryId={props.waitlistEntry.id}
            patientId={props.waitlistEntry.patient.id.asNumber()}
            practitionerId={props.waitlistEntry.practitioner.id.asNumber()}
         />
      );
   }

   if (props.waitlistEntry.status === 'REGISTERED') {
      return <ConfirmReservationButton waitlistEntry={props.waitlistEntry} />;
   }

   if (props.waitlistEntry.status === 'SUSPENDED') {
      return <RestoreEntryButton entryId={props.waitlistEntry.id} />;
   }

   return null;
};
